import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { SecuredBaseComponent } from '../base/secured-base.component';
import { Transaction } from '../models/Transaction';
import { TransactionService } from '../services/transaction.service';
import { PaymentMethodService } from '../services/payment-method.service';
import { PaymentMethod } from '../models/PaymentMethod';
import { ManagerService } from '../services/manager.service';
import { RefundTypeService } from '../services/refund-type.service';

@Component({
  selector: 'transaction',
  templateUrl: 'transaction.component.html',
  styleUrls: ['transaction.component.css']
})
export class TransactionComponent extends SecuredBaseComponent {

  constructor(public override snackBar: MatSnackBar, public override router: Router, public override managerService: ManagerService,
    private transactionService: TransactionService, private route: ActivatedRoute, private location: Location,
    public paymentMethodService: PaymentMethodService, public refundTypeService: RefundTypeService)
  {
    super(snackBar, router, managerService);
  }

  transactionId!: string;
  transaction!: Transaction;

  override ngOnInit() {
    super.ngOnInit();

    this.transactionId = this.route.snapshot.paramMap.get('id') || '';

    if (this.transactionId)
      this.loadTransaction();
    else
      this.router.navigate(['/main/transactions']);
  }

  get paymentMethod() {
    return PaymentMethod;
  }

  loadTransaction() {
    this.transactionService.get(this.transactionId).subscribe(
      result => { this.transaction = result as Transaction; },
      error => { this.showError(error, 'Get transaction has failed due to server error'); }
    );
  }

  print() {
    window.print();
  }

  back() {
    this.location.back();
  }
}
